const FOCAVEIS = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
].join(",");

function saindo(el) {
  return !!el.closest('[class*="-leave"]');
}

function visivel(el) {
  return !!el && el.getClientRects().length > 0;
}

function focaveisDe(raiz) {
  return Array.from(raiz.querySelectorAll(FOCAVEIS)).filter(
    (e) => visivel(e) && !saindo(e) && e.getAttribute("aria-hidden") !== "true"
  );
}

function ativos(raiz, seletor) {
  return Array.from(raiz.querySelectorAll(seletor)).filter((e) => !saindo(e));
}

function acharPicker(vm) {
  if (vm.$options.name === "v-date-picker") return vm;
  for (const filho of vm.$children) {
    const achado = acharPicker(filho);
    if (achado) return achado;
  }
  return null;
}

function vistaDe(conteudo) {
  if (ativos(conteudo, ".v-date-picker-years").length) return "YEAR";
  if (ativos(conteudo, ".v-date-picker-table--month").length) return "MONTH";
  return "DATE";
}

function alvoDe(conteudo) {
  const vista = vistaDe(conteudo);

  if (vista === "YEAR") {
    const anos = ativos(conteudo, ".v-date-picker-years li");
    return anos.find((li) => li.classList.contains("active")) || anos[0];
  }

  const tabela = vista === "MONTH" ? ".v-date-picker-table--month" : ".v-date-picker-table--date";
  const botoes = ativos(conteudo, `${tabela} button:not([disabled])`);
  return (
    botoes.find((b) => b.classList.contains("v-btn--active")) ||
    botoes.find((b) => b.classList.contains("v-date-picker-table__current")) ||
    botoes[0] ||
    focaveisDe(conteudo)[0]
  );
}

function focar(conteudo) {
  const alvo = alvoDe(conteudo);
  if (alvo) alvo.focus();
}

function textoDoCabecalho(conteudo) {
  const botao = ativos(conteudo, ".v-date-picker-header__value button")[0];
  return botao ? botao.textContent.trim() : "";
}

function rotularAnos(conteudo) {
  const lista = ativos(conteudo, ".v-date-picker-years")[0];
  if (!lista) return;

  lista.setAttribute("role", "listbox");
  lista.setAttribute("aria-label", "Anos");
  const anos = Array.from(lista.querySelectorAll("li"));
  const focado = anos.includes(document.activeElement) ? document.activeElement : null;
  const principal = focado || anos.find((li) => li.classList.contains("active")) || anos[0];

  anos.forEach((li) => {
    li.setAttribute("role", "option");
    li.setAttribute("aria-selected", String(li.classList.contains("active")));
    li.setAttribute("tabindex", li === principal ? "0" : "-1");
  });
}

function rotular(el, conteudo) {
  const estado = el.__calendario;
  const picker = estado.picker;

  conteudo.setAttribute("role", "dialog");
  conteudo.setAttribute("aria-modal", "true");
  conteudo.setAttribute("aria-label", estado.rotulo || rotuloPadrao(el));

  const vista = vistaDe(conteudo);
  const cabecalho = ativos(conteudo, ".v-date-picker-header__value button")[0];
  if (cabecalho) {
    const acao = vista === "DATE" ? "escolher outro mês" : "escolher outro ano";
    cabecalho.setAttribute("aria-label", `${cabecalho.textContent.trim()}, ${acao}`);
  }

  if (!picker) return rotularAnos(conteudo);
  const ano = picker.tableYear;

  ativos(conteudo, ".v-date-picker-table--month button").forEach((botao, i) => {
    const nome = new Date(ano, i, 1).toLocaleDateString("pt-BR", { month: "long", year: "numeric" });
    const selecionado = botao.classList.contains("v-btn--active");
    botao.setAttribute("aria-label", selecionado ? `${nome}, selecionado` : nome);
  });

  ativos(conteudo, ".v-date-picker-table--date button").forEach((botao) => {
    const data = new Date(ano, picker.tableMonth, Number(botao.textContent.trim()));
    const partes = [data.toLocaleDateString("pt-BR", { dateStyle: "full" })];
    if (botao.classList.contains("v-date-picker-table__current")) partes.push("hoje");
    if (botao.classList.contains("v-btn--active")) partes.push("selecionada");
    botao.setAttribute("aria-label", partes.join(", "));
  });

  rotularAnos(conteudo);
}

function rotuloPadrao(el) {
  const label = el.querySelector("label");
  const texto = label && label.textContent.trim();
  return texto ? `Calendário: ${texto}` : "Calendário";
}

function ehEscolhaFinal(alvo, picker) {
  const botao = alvo.closest("button:not([disabled])");
  if (!botao || saindo(botao) || !picker || picker.multiple) return false;

  if (botao.closest(".v-date-picker-table--date")) {
    if (picker.range) return Array.isArray(picker.value) && picker.value.length === 1;
    return true;
  }
  return !!botao.closest(".v-date-picker-table--month") && picker.type === "month";
}

function campoDe(el) {
  return el.querySelector("input:not([type=hidden])");
}

function focarCampo(el) {
  const campo = campoDe(el);
  if (campo) campo.focus();
}

function focarProximo(el, conteudo) {
  const campo = campoDe(el);
  if (!campo) return;

  const raizCampo = campo.closest(".v-input") || campo;
  const escopo = campo.closest(".v-dialog") || document.body;
  const proximo = focaveisDe(escopo).find(
    (e) =>
      !raizCampo.contains(e) &&
      !conteudo.contains(e) &&
      raizCampo.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING
  );

  (proximo || campo).focus();
}

function prenderTab(conteudo, evento) {
  const lista = focaveisDe(conteudo);
  if (!lista.length) return;

  const primeiro = lista[0];
  const ultimo = lista[lista.length - 1];
  const atual = document.activeElement;

  if (!conteudo.contains(atual)) {
    evento.preventDefault();
    (evento.shiftKey ? ultimo : primeiro).focus();
  } else if (evento.shiftKey && atual === primeiro) {
    evento.preventDefault();
    ultimo.focus();
  } else if (!evento.shiftKey && atual === ultimo) {
    evento.preventDefault();
    primeiro.focus();
  }
}

function navegarAnos(evento) {
  const li = evento.target.closest(".v-date-picker-years li");
  if (!li) return;

  if (evento.key === "Enter" || evento.key === " ") {
    evento.preventDefault();
    li.click();
    return;
  }

  const anos = Array.from(li.parentNode.querySelectorAll("li"));
  const atual = anos.indexOf(li);
  const indice = {
    ArrowDown: Math.min(atual + 1, anos.length - 1),
    ArrowUp: Math.max(atual - 1, 0),
    Home: 0,
    End: anos.length - 1,
  }[evento.key];
  if (indice === undefined) return;

  evento.preventDefault();
  anos.forEach((a) => a.setAttribute("tabindex", "-1"));
  anos[indice].setAttribute("tabindex", "0");
  anos[indice].focus();
}

function preparar(el, conteudo) {
  const estado = el.__calendario;
  if (estado.conteudo === conteudo) return;
  estado.conteudo = conteudo;

  const regiao = document.createElement("span");
  regiao.className = "sr-only";
  regiao.setAttribute("aria-live", "polite");
  conteudo.appendChild(regiao);
  estado.regiao = regiao;

  estado.teclado = (evento) => {
    if (evento.key === "Tab") prenderTab(conteudo, evento);
    else if (evento.key === "Escape") estado.cancelou = true;
    else navegarAnos(evento);
  };

  estado.clique = (evento) => {
    const vistaAntes = vistaDe(conteudo);
    const final = ehEscolhaFinal(evento.target, estado.picker);
    if (final) estado.escolheu = true;

    window.setTimeout(() => {
      const menu = estado.menu;
      if (!menu.isActive) return;
      if (final) {
        menu.isActive = false;
        return;
      }
      if (vistaDe(conteudo) !== vistaAntes) focar(conteudo);
    }, 0);
  };

  estado.observer = new MutationObserver(() => {
    if (!estado.menu.isActive) return;
    rotular(el, conteudo);

    const vista = vistaDe(conteudo);
    const texto = textoDoCabecalho(conteudo);
    if (vista === estado.vista && texto && texto !== estado.texto) regiao.textContent = texto;
    estado.vista = vista;
    estado.texto = texto;

    const ativo = document.activeElement;
    if (!ativo || ativo === document.body) focar(conteudo);
  });

  conteudo.addEventListener("keydown", estado.teclado);
  conteudo.addEventListener("click", estado.clique, true);
  estado.observer.observe(conteudo, { childList: true, subtree: true, characterData: true });
}

function quandoVisivel(el, callback, tentativas = 20) {
  const menu = el.__calendario.menu;
  const conteudo = menu.$refs.content;

  if (conteudo && conteudo.style.display !== "none" && visivel(conteudo)) {
    callback(conteudo);
  } else if (menu.isActive && tentativas > 0) {
    requestAnimationFrame(() => quandoVisivel(el, callback, tentativas - 1));
  }
}

function abrir(el) {
  const estado = el.__calendario;
  estado.escolheu = false;
  estado.cancelou = false;

  quandoVisivel(el, (conteudo) => {
    preparar(el, conteudo);
    estado.picker = acharPicker(estado.menu);
    rotular(el, conteudo);
    estado.vista = vistaDe(conteudo);
    estado.texto = textoDoCabecalho(conteudo);
    estado.regiao.textContent = "";
    focar(conteudo);
  });
}

function fechar(el) {
  const estado = el.__calendario;
  const conteudo = estado.conteudo;
  const ativo = document.activeElement;
  const focoPerdido = !ativo || ativo === document.body || (conteudo && conteudo.contains(ativo));

  if (estado.escolheu && conteudo) {
    focarProximo(el, conteudo);
  } else if (estado.cancelou || focoPerdido) {
    requestAnimationFrame(() => focarCampo(el));
  }

  estado.escolheu = false;
  estado.cancelou = false;
}

export default {
  inserted(el, binding, vnode) {
    const menu = vnode.componentInstance;
    if (!menu) return;

    el.__calendario = { menu, rotulo: binding.value || null };
    el.__calendario.parar = menu.$watch("isActive", (aberto) => (aberto ? abrir(el) : fechar(el)));
    if (menu.isActive) abrir(el);
  },
  componentUpdated(el, binding) {
    if (el.__calendario) el.__calendario.rotulo = binding.value || null;
  },
  unbind(el) {
    const estado = el.__calendario;
    if (!estado) return;

    estado.parar();
    if (estado.observer) estado.observer.disconnect();
    if (estado.conteudo) {
      estado.conteudo.removeEventListener("keydown", estado.teclado);
      estado.conteudo.removeEventListener("click", estado.clique, true);
    }
    if (estado.regiao) estado.regiao.remove();
    delete el.__calendario;
  },
};
